import type { ReactNode } from 'react'
import { cx } from './ui'

/**
 * Short phrases set apart by space, never strung together with a middle dot
 * (Horizon: "3h of work   1 without an estimate", as Today's shape line does).
 * Falsy parts are dropped, so a caller can list the optional ones inline.
 */
export const Phrases = ({
  parts,
  className,
  as: Tag = 'span',
  ...rest
}: {
  parts: (ReactNode | false | null | undefined | '')[]
  className?: string
  as?: 'span' | 'div' | 'p'
  'data-testid'?: string
}) => (
  <Tag className={cx('flex flex-wrap items-baseline gap-x-3 gap-y-0.5', className)} {...rest}>
    {parts
      .filter((p) => p !== false && p !== null && p !== undefined && p !== '')
      .map((p, i) => (
        <span key={i} className="min-w-0">
          {p}
        </span>
      ))}
  </Tag>
)
